import { createAction } from "@reduxjs/toolkit";

export const getUser = createAction("users/getUser");
